import { 
  faBus, 
  faHandHoldingHeart, 
  faHome,
  faLandmark, 
  faPersonDigging, 
  faPiggyBank, 
  faQuestion, 
  faSeedling, 
  faStethoscope, 
  faUserGraduate,
  faSearch,
  faBinoculars,
  faVideo,
  faMapLocationDot,
  faPhone,
  IconDefinition,
  faChartSimple,
  faCity,
  faWater,
  faFaucet,
  faHelmetSafety,
  faMoneyBillTrendUp,
} from '@fortawesome/free-solid-svg-icons';

type IconDef = {
  [key: string]: IconDefinition;
}

export const iconesMap: IconDef = {
  'Home':faHome,
  'Zeladoria':faPersonDigging,
  'Mobilidade Urbana':faBus,
  'Educação':faUserGraduate,
  'Saúde':faStethoscope,
  'Social':faHandHoldingHeart,
  'Ambiental':faSeedling,
  'Fazenda': faPiggyBank,
  'Ações de governo': faLandmark,
  'Outros': faQuestion,
  'Busca': faSearch,
  'ObservaPOA': faBinoculars,
  '156+POA': faPhone,
  'Segurança Pública': faVideo,
  'Mapas': faMapLocationDot,
  'Monitoramento': faChartSimple,
  'Serviços Urbanos': faCity,
  'DMAE': faFaucet,
  'Defesa Civil': faHelmetSafety,
  'Desenvolvimento Econômico': faMoneyBillTrendUp,
};